/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { JofiCanton } from '../models/jofi-canton';

@Injectable({
  providedIn: 'root',
})
export class JofiContentDeliveryCantonsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation cantonsDeliveryControllerFindAll
   */
  static readonly CantonsDeliveryControllerFindAllPath = '/v1/content-delivery/cantons';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cantonsDeliveryControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  cantonsDeliveryControllerFindAll$Response(params?: {

    /**
     * This request requires a valid API key.
     */
    'x-api-key'?: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<JofiCanton>>> {

    const rb = new RequestBuilder(this.rootUrl, JofiContentDeliveryCantonsService.CantonsDeliveryControllerFindAllPath, 'get');
    if (params) {
      rb.header('x-api-key', params['x-api-key'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<JofiCanton>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `cantonsDeliveryControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cantonsDeliveryControllerFindAll(params?: {

    /**
     * This request requires a valid API key.
     */
    'x-api-key'?: string;
    context?: HttpContext
  }
): Observable<Array<JofiCanton>> {

    return this.cantonsDeliveryControllerFindAll$Response(params).pipe(
      map((r: StrictHttpResponse<Array<JofiCanton>>) => r.body as Array<JofiCanton>)
    );
  }

  /**
   * Path part for operation cantonsDeliveryControllerFindOne
   */
  static readonly CantonsDeliveryControllerFindOnePath = '/v1/content-delivery/cantons/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cantonsDeliveryControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  cantonsDeliveryControllerFindOne$Response(params: {
    id: string;

    /**
     * This request requires a valid API key.
     */
    'x-api-key'?: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<JofiCanton>> {

    const rb = new RequestBuilder(this.rootUrl, JofiContentDeliveryCantonsService.CantonsDeliveryControllerFindOnePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.header('x-api-key', params['x-api-key'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<JofiCanton>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `cantonsDeliveryControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cantonsDeliveryControllerFindOne(params: {
    id: string;

    /**
     * This request requires a valid API key.
     */
    'x-api-key'?: string;
    context?: HttpContext
  }
): Observable<JofiCanton> {

    return this.cantonsDeliveryControllerFindOne$Response(params).pipe(
      map((r: StrictHttpResponse<JofiCanton>) => r.body as JofiCanton)
    );
  }

}
